var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showLoader)?_c('div',{staticClass:"overlay"},[_c('img',{staticStyle:{"width":"24rem","height":"13rem"},attrs:{"src":"https://dbmenos.com/img/gifs/DB_Logo_Blue3_GIF.gif"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }